export class EntProductsFilter {
  page: number;
  size: number;
  productTypeIds: number[]  | null;
  directionId: number  | null;
  areaId: number  | null;
  regionId: number  | null;
  productionCountFrom: number  | null;
  productionCountTo: number  | null;
  salesCountFrom: number  | null;
  salesCountTo: number  | null;
  createdFrom: string  | null;
  createdTo: string  | null;
  deleted: boolean = false;

  constructor() {
    this.page = 1;
    this.size = 30;
    this.productTypeIds = null;
    this.createdTo = null;
    this.createdFrom = null;
    this.directionId = null;
    this.areaId = null;
    this.regionId = null;
    this.productionCountFrom = null;
    this.productionCountTo = null;
    this.salesCountFrom = null;
    this.salesCountTo = null;
  }

  
}
